import React from "react";
import { Box, Button, Switch, Typography, useTheme } from "@mui/material";
import { FormattedMessage } from "react-intl";
import AddIcon from "@mui/icons-material/Add";
import { getAssetHierarchyPalette, getContainedButtonSx, getSectionBoxSx, getSwitchSx } from "../assetHierarchyStyles";
import { HideIfNoRole } from "../../../auth/authUi";
import { CMMS_MANAGER_ROLES } from "../cmmsRoles";
import messages from "../messages";

export default function AssetHierarchyToolbar({ canAddNode, includeInactive, onAddNode, onIncludeInactiveChange }) {
  const theme = useTheme();
  const cmmsColors = getAssetHierarchyPalette(theme.palette.mode);

  return (
    <Box
      sx={{
        display: "grid",
        gridTemplateColumns: { xs: "1fr", md: "auto auto" },
        alignItems: "center",
        gap: 1.5,
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1, flexWrap: "wrap" }}>
        {/* POST is Cmms_Manager server-side, so this button can only 403 for anyone else —
            same gate as the add/edit/move/delete controls in the details panel. */}
        <HideIfNoRole anyOf={CMMS_MANAGER_ROLES}>
          <Button variant="contained" startIcon={<AddIcon />} onClick={onAddNode} disabled={!canAddNode} sx={getContainedButtonSx(cmmsColors)}>
            <FormattedMessage {...messages.addNode} />
          </Button>
        </HideIfNoRole>
      </Box>

      <Box
        sx={{
          ...getSectionBoxSx(cmmsColors),
          justifySelf: { md: "end" },
          py: 1.25,
          px: 1.5,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          gap: 1.5,
          minWidth: { md: 250 },
        }}
      >
        <Box>
          <Typography variant="body2" sx={{ color: cmmsColors.text, fontWeight: 700 }}>
            <FormattedMessage {...messages.includeInactive} />
          </Typography>
          <Typography variant="caption" sx={{ color: cmmsColors.mutedText }}>
            <FormattedMessage {...messages.includeInactiveHint} />
          </Typography>
        </Box>
        <Switch
          checked={includeInactive}
          onChange={(event) => onIncludeInactiveChange(event.target.checked)}
          sx={getSwitchSx(cmmsColors)}
        />
      </Box>
    </Box>
  );
}
